var _path, _path2, _path3, _path4, _rect, _path5, _rect2, _circle, _circle2, _path6, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTime(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    enableBackground: "new 0 0 140 140",
    viewBox: "0 0 140 140",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#dc2626",
    d: "M134,70c0,2-0.1,3.9-0.3,5.8c-2.7,29.6-25.5,53.5-54.7,57.5c-2.9,0.4-5.9,0.6-9,0.6c-35.3,0-64-28.7-64-64 C6,34.7,34.7,6,70,6C105.4,6,134,34.7,134,70z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M103.1,45.2l-7.5-6.6c-0.4-0.4-1-0.3-1.4,0.1l-3.3,3.7c0,0-0.1,0.1-0.1,0.1c0,0,0,0.1-0.1,0.1c0,0.1-0.1,0.2-0.1,0.2 c-0.1,0.3,0,0.6,0.3,0.9l0,0c0,0,0,0.1,0.1,0.1l0,0l2.1,2.1l-1.3,1.5L75.6,31.2c0,0,0,0,0,0v0h0c-0.3-0.3-0.6-0.5-0.9-0.7 c-0.2-0.1-0.4-0.2-0.7-0.3c-0.4-0.1-0.8-0.2-1.2-0.2h-5.4c-2.2,0-4,1.8-4,4c0,0.2,0,0.3,0,0.5c0,0.3,0.1,0.5,0.1,0.7 c0.1,0.3,0.2,0.5,0.3,0.7c0,0.1,0.1,0.2,0.2,0.3c0.2,0.2,0.3,0.5,0.6,0.7l3.4,3.5c-0.1,0-0.2,0-0.3,0c0,0-0.1,0-0.1,0 c-0.2,0-0.4,0-0.6,0c-0.5,0-0.9,0.1-1.4,0.1c-0.3,0-0.5,0.1-0.8,0.1c-0.1,0-0.3,0-0.4,0.1c-0.4,0.1-0.8,0.1-1.1,0.2 c-0.1,0-0.2,0-0.3,0.1c-0.4,0.1-0.8,0.2-1.2,0.3c-0.4,0.1-0.7,0.2-1.1,0.3c-0.3,0.1-0.7,0.2-1,0.3c0,0,0,0,0,0 c-0.6,0.2-1.2,0.4-1.8,0.6c-0.3,0.1-0.7,0.3-1,0.4c-0.3,0.1-0.6,0.3-0.9,0.4c-0.3,0.1-0.7,0.3-1,0.5c-0.3,0.1-0.6,0.3-0.9,0.4 c-0.6,0.3-1.2,0.6-1.8,1l-6.5-6.5c-0.4-0.4-1-0.5-1.4-0.1l-7.5,6.6c-0.4,0.4-0.5,1-0.1,1.4l3.3,3.7l2.8,2.8 c-0.3,0.4-0.6,0.7-0.9,1.1c0,0,0,0,0,0c-0.3,0.4-0.6,0.8-0.8,1.2c-0.4,0.5-0.7,1-1,1.6c-0.2,0.3-0.3,0.6-0.5,0.9 c-0.2,0.4-0.5,0.8-0.7,1.3c0,0,0,0,0,0c-0.3,0.5-0.5,1-0.7,1.5c0,0,0,0,0,0c-0.2,0.5-0.5,1-0.7,1.6c-0.1,0.3-0.3,0.7-0.4,1 c-0.1,0.3-0.2,0.5-0.3,0.8c-0.1,0.4-0.2,0.7-0.3,1.1c-0.1,0.4-0.2,0.8-0.3,1.1c-0.1,0.4-0.2,0.8-0.3,1.1c-0.2,0.9-0.4,1.8-0.5,2.7 c0,0.3-0.1,0.6-0.1,0.9c-0.1,1-0.2,1.9-0.2,2.9c0,0.2,0,0.4,0,0.5c0,0.2,0,0.4,0,0.5c0,0.9,0,1.8,0.1,2.7c0.1,0.6,0.1,1.2,0.2,1.8 c0.1,1.1,0.3,2.2,0.6,3.3c0,0.1,0.1,0.3,0.1,0.4c0.1,0.4,0.2,0.7,0.3,1.1c0.1,0.2,0.1,0.4,0.2,0.7c0.1,0.5,0.3,0.9,0.4,1.3 c0.1,0.4,0.3,0.8,0.4,1.2c0.3,1,0.8,1.9,1.2,2.8c0.2,0.4,0.4,0.8,0.6,1.1c0.2,0.4,0.4,0.8,0.6,1.1c0.1,0.2,0.3,0.5,0.4,0.7 c0.2,0.4,0.4,0.7,0.7,1.1c0.1,0.2,0.3,0.4,0.4,0.6c0.2,0.2,0.3,0.5,0.5,0.7c0.2,0.2,0.3,0.5,0.5,0.7c0.2,0.2,0.4,0.5,0.6,0.7 c0.2,0.2,0.4,0.5,0.6,0.7c0.2,0.2,0.4,0.5,0.6,0.7c0.2,0.2,0.4,0.4,0.6,0.6c0.2,0.2,0.4,0.4,0.6,0.6s0.4,0.4,0.6,0.6 c0.2,0.2,0.5,0.5,0.7,0.7L79,133.4c29.2-4.1,52.1-27.9,54.7-57.5L103.1,45.2z",
    opacity: 0.3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#263a46",
    d: "M75.6,31.2L75.6,31.2c-0.3-0.3-0.6-0.5-1-0.7c-0.2-0.1-0.4-0.2-0.7-0.3c-0.4-0.1-0.8-0.2-1.2-0.2h-5.4 c-2.2,0-4,1.8-4,4c0,0.2,0,0.3,0,0.5c0,0.3,0.1,0.5,0.1,0.7c0.1,0.3,0.2,0.5,0.3,0.7c0,0.1,0.1,0.2,0.2,0.3 c0.2,0.2,0.3,0.5,0.6,0.7c0.7,0.7,1.7,1.1,2.8,1.1H69v4.3h2V38h1.7c2.2,0,4-1.8,4-4C76.7,32.9,76.3,31.9,75.6,31.2z M72.7,36 h-5.4c-1.1,0-2-0.9-2-2s0.9-2,2-2h5.4c1.1,0,2,0.9,2,2S73.8,36,72.7,36z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#2a414e",
    d: "M94.2,38.7l-3.3,3.7c-0.4,0.4-0.3,1,0.1,1.4l7.5,6.6c0.4,0.4,1,0.3,1.4-0.1l3.3-3.7 c0.4-0.4,0.3-1-0.1-1.4l-7.5-6.6C95.2,38.2,94.6,38.3,94.2,38.7z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 4,
    x: 89.8,
    y: 47.4,
    fill: "#f3f3f3",
    transform: "rotate(-48.515 92.784 49.363)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#2a414e",
    d: "M45.8,38.7l3.3,3.7c0.4,0.4,0.3,1-0.1,1.4l-7.5,6.6c-0.4,0.4-1,0.3-1.4-0.1l-3.3-3.7 c-0.4-0.4-0.3-1,0.1-1.4l7.5-6.6C44.8,38.2,45.4,38.3,45.8,38.7z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 6,
    x: 45.2,
    y: 46.4,
    fill: "#f3f3f3",
    transform: "rotate(-41.485 47.221 49.363)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 70,
    cy: 75.1,
    r: 34.9,
    fill: "#314d5c"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 70,
    cy: 75.1,
    r: 29.1,
    fill: "#f7f8f9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#e45647",
    d: "M70,56.4c0,0-4.7,16.1-4.7,18.7c0,2.6,2.1,4.7,4.7,4.7c2.6,0,4.7-2.1,4.7-4.7C74.7,72.6,70,56.4,70,56.4z"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 3.1,
    height: 4.2,
    x: 68.4,
    y: 49.7,
    fill: "#939393"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 3.1,
    height: 4.2,
    x: 69,
    y: 96.5,
    fill: "#939393"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 4.2,
    height: 3.1,
    x: 84.5,
    y: 56.9,
    fill: "#939393",
    transform: "rotate(-45.001 86.614 58.422)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 4.2,
    height: 3.1,
    x: 51.8,
    y: 90.3,
    fill: "#939393",
    transform: "rotate(-45.001 53.905 91.866)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 4.2,
    height: 3.1,
    x: 91.6,
    y: 73.3,
    fill: "#939393"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 4.2,
    height: 3.1,
    x: 44.8,
    y: 73.8,
    fill: "#939393"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 3.1,
    height: 4.2,
    x: 85.4,
    y: 89.4,
    fill: "#939393",
    transform: "rotate(-45.009 86.973 91.495)"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 3.1,
    height: 4.2,
    x: 52,
    y: 56.7,
    fill: "#939393",
    transform: "rotate(-45.001 53.537 58.789)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 70,
    cy: 75.1,
    r: 2.6,
    fill: "#f7f8f9"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/time.ef4880ddfbad0813ddd7db8bfb15f550.svg";
export { ForwardRef as ReactComponent };